import { v4 as uuid } from 'uuid';

const LoaderBussines = () => {
  const generateCards = () => {
    const list = Array(19).fill('.');
    return list.map(() => {
      return (
        <div id="cardBussines" key={uuid()}>
          <div className="boxCard">
            <div className="idContainer">
              <div className="w-12 h-6 rounded-md animationLoader" />
            </div>
            <div className="dateContainer">
              <div className="w-12 h-6 rounded-md animationLoader" />
            </div>
            <div className="rfcContainer">
              <div className="w-12 h-6 rounded-md animationLoader" />
            </div>
            <div className="nameContainer">
              <div className="w-16 h-6 rounded-md animationLoader" />
            </div>
            <div className="statusContainer">
              <div className="approved animationLoader" />
            </div>
            <div className="creditContainer">
              <div className="w-12 h-6 animationLoader" />
            </div>
          </div>
        </div>
      );
    });
  };
  return <div className="w-full">{generateCards()}</div>;
};

export default LoaderBussines;
